/**
 * Yes/No control for a Q&A's inclusion in chatbot retrieval.
 * Shared by the QA Management table and the detail modal.
 */

import React from 'react';

interface QAIncludeToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Accessible name for the group, e.g. "Include <question>" */
  label: string;
  yesTitle?: string;
  noTitle?: string;
}

export const QAIncludeToggle: React.FC<QAIncludeToggleProps> = ({
  value,
  onChange,
  disabled = false,
  label,
  yesTitle,
  noTitle,
}) => (
  <div className="qa-include-toggle" role="group" aria-label={label}>
    <button
      type="button"
      className={`qa-include-option${value ? ' active-yes' : ''}`}
      onClick={() => onChange(true)}
      disabled={disabled}
      aria-pressed={value}
      title={yesTitle}
    >
      Yes
    </button>
    <button
      type="button"
      className={`qa-include-option${value ? '' : ' active-no'}`}
      onClick={() => onChange(false)}
      disabled={disabled}
      aria-pressed={!value}
      title={noTitle}
    >
      No
    </button>
  </div>
);
